import React from 'react';
import { Mic } from 'lucide-react';

const VoiceToTextButton = ({
  onToggle,
  isRecording,
  disabled,
  supported = true
}) => {
  const isDisabled = disabled || !supported;

  return (
    <div className="relative group">
      <button
        type="button"
        onClick={onToggle}
        disabled={isDisabled}
        aria-pressed={isRecording}
        aria-label="Dictate"
        title={isDisabled ? undefined : 'Dictate'}
        className={`
          h-11 w-11
          rounded-full
          flex
          items-center
          justify-center
          transition-all
          duration-150
          ${isDisabled
            ? 'cursor-not-allowed text-gray-400 dark:text-gray-600'
            : isRecording
              ? 'text-red-600 bg-red-50 hover:bg-red-100 dark:text-red-300 dark:bg-red-900/30 dark:hover:bg-red-900/40'
              : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800'
          }
        `}
      >
        <Mic size={18} strokeWidth={2.2} />
      </button>
    </div>
  );
};

export default VoiceToTextButton;
